import { P2GBox, P2GImage } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { RoyalMailProvider } from '~/lib/consts/providers';
import { QuoteProviderAccountApiModel, QuoteProviderApiModel } from '~/lib/api/smartsend/types';
import useProviderName from '../../../hooks/use-provider-name';
import { useServiceLogo } from '../../../../../hooks/use-service-logo';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { CurrentSelectionType } from './utils/CurrentSelectionType';
import { AppCard } from '~/components/card/app-card';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  accounts: QuoteProviderApiModel[];
  currentSelection: CurrentSelectionType;
  selectProviderAccount?: (account: QuoteProviderAccountApiModel) => void;
  children?: React.ReactNode;
}

const ProviderSelection: React.FC<props> = (props) => {
  const providerName = useProviderName();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const { getSrc } = useServiceLogo();

  return (
    <P2GGrid container spacing={2} direction="column">
      {props.children && <P2GGrid item>{props.children}</P2GGrid>}
      {props.accounts.map((p) =>
        p.Accounts.map((a) => (
          <P2GGrid item key={`${p.Id}_${a.Id}`}>
            <div style={{ cursor: 'pointer' }}>
              <AppCard>
                <P2GBox p={2} onClick={() => props.selectProviderAccount?.(a)}>
                  <P2GGrid container alignItems="center" gap={2} wrap="nowrap">
                    <P2GGrid item>
                      <P2GImage
                        style={{ width: '50px' }}
                        src={getSrc({ Provider: p.Name, Id: a.Id }) || ''}
                        alt="Image"
                      />
                    </P2GGrid>
                    <P2GGrid item flexGrow={1}>
                      {a.Provider === RoyalMailProvider ? (
                        <>
                          <P2GText component="p">
                            <strong>
                              {t('ROYAL_MAIL_OBA_ACCOUNT_SERVICES', {
                                defaultValue: 'Royal Mail OBA Account Services'
                              })}
                            </strong>
                          </P2GText>
                          <P2GText>
                            {t('ALL_ROYAL_MAIL_SERVICES', {
                              defaultValue: 'Access all Royal Mail services and shipping prices'
                            })}
                          </P2GText>
                        </>
                      ) : (
                        <>
                          <P2GText component="p">
                            <strong>
                              <Trans
                                t={t}
                                i18nKey="SELECT_PROVIDER"
                                values={{ provider: providerName(a.Provider) }}
                                defaults="{{provider}} Services"
                              />
                            </strong>
                          </P2GText>
                          <P2GText>
                            <Trans
                              t={t}
                              i18nKey="SELECT_PROVIDER_DESCRIPTION"
                              values={{ provider: providerName(a.Provider) }}
                              defaults="Access {{provider}}'s extensive parcel service options and low shipping prices"
                            />
                          </P2GText>
                        </>
                      )}
                    </P2GGrid>
                    <P2GGrid item>
                      <P2GCheckBoxLegacy
                        onChange={() => {}}
                        checked={false}
                        labelPlacement="end"
                        id="provider-selection-checkbox"
                        label={null}
                        variant="primary"
                        error={false}
                      />
                    </P2GGrid>
                  </P2GGrid>
                </P2GBox>
              </AppCard>
            </div>
          </P2GGrid>
        ))
      )}
    </P2GGrid>
  );
};

export default ProviderSelection;
